// extracted by mini-css-extract-plugin
export default {"rating":"ReviewRating_rating__1mUqV","rating-star":"ReviewRating_rating-star__uHp09","rating-star-blank":"ReviewRating_rating-star-blank__Afi7A"};